import Arrow from '@c/icons/buttons/ArrowButton';

const SkeletonCarouselComponent = () => {
  return (
    <div className="w-full min-w-[0rem] ">
      <div className="relative w-full">
        {/* left arrow */}
        <div className="absolute -left-8 top-0 z-20 hidden h-full items-center sm:flex">
          <Arrow variant="left" onClick={() => { }} />
        </div>

        <div className="no-scrollbar w-full overflow-x-scroll scroll-smooth px-4 pb-[1rem] sm:px-0 lg:overflow-x-hidden">
          <div className="mobile-zoom-product-card-container flex w-min gap-[1.6rem] p-4 ">
            {Array.from({ length: 12 }).map((_, i) => (
              <div
                key={i}
                className="skeleton-loader"
                style={{
                  width: '150px',
                  height: '200px',
                  borderRadius: '10px',
                  backgroundColor: '#e0e0e0',
                  background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'loading 1.5s infinite',
                }}
              ></div>
            ))}
          </div>
        </div>
        {/* right arrow */}
        <div className="absolute -right-8 top-0 z-10 hidden h-full items-center sm:flex">
          <Arrow variant="right" onClick={() => { }} />
        </div>
      </div>

      <style>{`
        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </div>
  );
};

export default SkeletonCarouselComponent;
